const couponsList = [
    {
        id: 1,
        discount: "$15.9",
        couponTitle: "Winter Gift Voucher",
        code: "WINTER145",
        productType: "Other Accessories",
        startDate: "23 Dec, 2022",
        endDate: "15 Jan, 2023",
        status: "Active"
    },
    {
        id: 2,
        discount: "50%",
        couponTitle: "Back Friday",
        code: "FRIDAY50",
        productType: "Furniture",
        startDate: "14 Mar, 2022",
        endDate: "29 Mar, 2022",
        status: "Active"
    },
    {
        id: 3,
        discount: "20%",
        couponTitle: "Gift Voucher",
        code: "TONER20",
        productType: "Lighting",
        startDate: "05 Aug, 2022",
        endDate: "12 Sep, 2022",
        status: "Expired"
    },
    {
        id: 4,
        discount: "$10",
        couponTitle: "Cyber Sale",
        code: "CYBER10",
        productType: "Footwear",
        startDate: "16 Aug, 2022",
        endDate: "15 Sep, 2022",
        status: "Expired"
    },
    {
        id: 5,
        discount: "60%",
        couponTitle: "Exclusive Sale",
        code: "SALES60",
        productType: "Clothing",
        startDate: "11 Sep, 2022",
        endDate: "03 Oct, 2022",
        status: "Active"
    },
    {
        id: 6,
        discount: "$15",
        couponTitle: "Great Festival",
        code: "FESTIVAL15",
        productType: "Headphones",
        startDate: "09 Dec, 2022",
        endDate: "21 Dec, 2022",
        status: "Expired"
    },
    {
        id: 7,
        discount: "40%",
        couponTitle: "Summer Sale",
        code: "SUMMER40",
        productType: "Beauty & Personal Care",
        startDate: "05 Oct, 2022",
        endDate: "24 Nov, 2022",
        status: "Expired"
    },
    {
        id: 8,
        discount: "20%",
        couponTitle: "Christmas Sale",
        code: "CHRISTMAS20",
        productType: "Headphones",
        startDate: "15 Jan, 2023",
        endDate: "13 Feb, 2023",
        status: "Active"
    },
    {
        id: 9,
        discount: "$10",
        couponTitle: "Summer Sale",
        code: "SUMMER10",
        productType: "Furniture",
        startDate: "19 Nov, 2022",
        endDate: "28 Dec, 2022",
        status: "Expired"
    },
    {
        id: 10,
        discount: "$25",
        couponTitle: "Gift Voucher",
        code: "FESTIVAL15",
        productType: "Watch",
        startDate: "02 Dec, 2022",
        endDate: "07 Jan, 2023",
        status: "Active"
    },
    {
        id: 11,
        discount: "$10",
        couponTitle: "Cyber Sale",
        code: "CYBER10",
        productType: "Footwear",
        startDate: "16 Aug, 2022",
        endDate: "15 Sep, 2022",
        status: "Expired"
    }
]

export { couponsList }